<template>
  <div class="threshold d-flex">
    <!-- 静态阈值 -->
    <div class="border-end border-end-dashed">
      <div
        class="threshold-head bg-light d-flex pt-1 pb-1 ps-3 pe-3 justify-content-between align-items-center"
      >
        <div class="fw-bold me-4 fs-16">{{this.$t('page.atlas-analysis.StaticThreshold')}}</div>
        <div
          class="form-check form-switch form-switch-right form-switch-md"
          @click.stop="handleAlertInfo"
        >
          <input
            class="form-check-input code-switcher mt-0"
            type="checkbox"
            v-model="showThreshold.static_threshold.state"
            @change="handleStaticStat"
            :disabled="!recordThreshold"
          />
        </div>
        <div class="fs-14 me-3 ms-1">
          {{ showThreshold.static_threshold.state ? this.$t('page.expert-system.Enabled') : this.$t('page.expert-system.NotEnabled') }}
        </div>
        <div>
          <i
            class="ri-pencil-fill text-primary fs-20"
            @click.stop="clickEdit()"
            v-show="!isEdit"
          ></i>
          <span v-show="isEdit">
            <i
              class="ri-close-circle-line text-primary fs-20 me-1"
              @click.stop="handleCancel()"
            ></i>
            <i
              class="ri-checkbox-circle-line text-primary fs-20"
              @click.stop="handleEdit()"
            ></i>
          </span>
        </div>
      </div>
      <div class="row pt-1 pb-1 ps-3 pe-3">
        <div class="col">
          <div>{{this.$t('page.gauge_point.runnable_low')}}</div>
          <div>
            <span v-show="!isEdit">{{
              showThreshold.static_threshold.operationThresholdLow
            }}</span>
            <input
              style="width: 95px"
              v-show="isEdit"
              v-model="showThreshold.static_threshold.operationThresholdLow"
              type="text"
              class="form-control multiselect-single-label-text noborder_input p-0"
              :class="{
                'is-invalid':
                  submitted &&
                  v$.showThreshold.static_threshold.operationThresholdLow
                    .$error,
              }"
              required
            />
            <div
              v-for="(item, index) in v$.showThreshold.static_threshold
                .operationThresholdLow.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="item.$message">{{ item.$message }}</span>
            </div>
          </div>
        </div>
        <div class="col">
          <div>{{this.$t('page.gauge_point.runnable_high')}}</div>
          <div>
            <span v-show="!isEdit">{{
              showThreshold.static_threshold.operationThresholdHigh
            }}</span>
            <input
              style="width: 95px"
              v-show="isEdit"
              v-model="showThreshold.static_threshold.operationThresholdHigh"
              type="text"
              class="form-control multiselect-single-label-text noborder_input p-0"
              :class="{
                'is-invalid':
                  submitted &&
                  v$.showThreshold.static_threshold.operationThresholdHigh
                    .$error,
              }"
              required
            />
            <div
              v-for="(item, index) in v$.showThreshold.static_threshold
                .operationThresholdHigh.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="item.$message">{{ item.$message }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row pt-1 pb-1 ps-3 pe-3">
        <div class="col">
          <div>{{this.$t('page.gauge_point.ideal_low')}}</div>
          <div>
            <span v-show="!isEdit">{{
              showThreshold.static_threshold.standardThresholdLow
            }}</span>
            <input
              style="width: 95px"
              v-show="isEdit"
              v-model="showThreshold.static_threshold.standardThresholdLow"
              type="text"
              class="form-control multiselect-single-label-text noborder_input p-0"
              :class="{
                'is-invalid':
                  submitted &&
                  v$.showThreshold.static_threshold.standardThresholdLow.$error,
              }"
              required
            />
            <div
              v-for="(item, index) in v$.showThreshold.static_threshold
                .standardThresholdLow.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="item.$message">{{ item.$message }}</span>
            </div>
          </div>
        </div>
        <div class="col">
          <div>{{this.$t('page.gauge_point.ideal_high')}}</div>
          <div>
            <span v-show="!isEdit">{{
              showThreshold.static_threshold.standardThresholdHigh
            }}</span>
            <input
              style="width: 95px"
              v-show="isEdit"
              v-model="showThreshold.static_threshold.standardThresholdHigh"
              type="text"
              class="form-control multiselect-single-label-text noborder_input p-0"
              :class="{
                'is-invalid':
                  submitted &&
                  v$.showThreshold.static_threshold.standardThresholdHigh
                    .$error,
              }"
              required
            />
            <div
              v-for="(item, index) in v$.showThreshold.static_threshold
                .standardThresholdHigh.$errors"
              :key="index"
              class="invalid-feedback"
            >
              <span v-if="item.$message">{{ item.$message }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 动态阈值 -->
    <div>
      <div
        class="threshold-head bg-light d-flex pt-1 pb-1 ps-3 pe-3 justify-content-between align-items-center"
      >
        <div class="fw-bold me-4 fs-16">{{this.$t('page.atlas-analysis.DT')}}</div>
        <div
          class="form-check form-switch form-switch-right form-switch-md"
          style="cursor: not-allowed"
        >
          <input
            class="form-check-input code-switcher mt-0"
            type="checkbox"
            v-model="showThreshold.dynamic_threshold.state"
            @change="handleDynamicStat"
          />
        </div>
        <div class="fs-14 me-3 ms-1">
          {{ showThreshold.dynamic_threshold.state ? this.$t('page.expert-system.Enabled') : this.$t('page.expert-system.NotEnabled') }}
        </div>
        <!--  <div>
            <i class="ri-pencil-fill text-primary fs-20" @click.stop="clickDyEdit()" v-show="!dyEdit"></i>
            <span v-show="dyEdit">
              <i class="ri-close-circle-line text-primary fs-20 me-1" @click.stop="handleDyCancel()"></i>
              <i class="ri-checkbox-circle-line text-primary fs-20" @click.stop="handleDyEdit()"></i>
            </span>
          </div>-->
        <div class="opacity-0">
          <i class="ri-pencil-fill text-primary fs-20"></i>
        </div>
      </div>
      <div class="row pt-1 pb-1 ps-3 pe-3">
        <!-- <div class="col">
            <div>可运行（低）</div>
            <div>
              {{showThreshold.dynamic_threshold.operationThresholdLow}}
            </div> 
            <div>
              <span v-show="!dyEdit">{{showThreshold.dynamic_threshold.operationThresholdLow}}</span>
                <input 
                  style="width:95px"
                  v-show="dyEdit"
                  v-model="showThreshold.dynamic_threshold.operationThresholdLow"
                  type="text"
                  class="form-control multiselect-single-label-text noborder_input p-0"
               />
              
            </div>-->
      </div>
      <div class="col">
        <!-- <div>可运行（高）</div>
            <div>{{showThreshold.dynamic_threshold.operationThresholdHigh}}</div> 

            <div>
              <span v-show="!dyEdit">{{showThreshold.dynamic_threshold.operationThresholdHigh}}</span>
                <input 
                  style="width:95px"
                  v-show="dyEdit"
                  v-model="showThreshold.dynamic_threshold.operationThresholdHigh"
                  type="text"
                  class="form-control multiselect-single-label-text noborder_input p-0"
                 />
            
            </div>
          </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import {
  putMeasureStaticThres,
  putMeasureStaticThresStat,
  putDynamicStat,
} from "@/service/index.js";
import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import Swal from "sweetalert2";
import _ from "loadsh";
import i18n from "@/i18n";
const number = helpers.regex(/^(-|\+)?\d+(\.\d+)?$/);
export default {
  props: {
    instance_id: String,
    measure_id: String,
    refresh_frequency: String,
    recordThreshold: Boolean,
    currentInfo: Object, //当前点击设备的info
    selectedMeasure: {
      type: Object,
      defaults: () => {
        return {};
      },
    },
    threshold: {
      type: Object,
      defaults: () => {
        return {};
      },
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  validations: {
    showThreshold: {
      static_threshold: {
        operationThresholdLow: {
          required: helpers.withMessage(i18n.global.t('page.expert-system.CanontBeEmpty'), required),
          number: helpers.withMessage(i18n.global.t('page.expert-system.MustBeANumber'), number),
        },
        standardThresholdLow: {
          required: helpers.withMessage(i18n.global.t('page.expert-system.CanontBeEmpty'), required),
          number: helpers.withMessage(i18n.global.t('page.expert-system.MustBeANumber'), number),
        },
        standardThresholdHigh: {
          required: helpers.withMessage(i18n.global.t('page.expert-system.CanontBeEmpty'), required),
          number: helpers.withMessage(i18n.global.t('page.expert-system.MustBeANumber'), number),
        },
        operationThresholdHigh: {
          required: helpers.withMessage(i18n.global.t('page.expert-system.CanontBeEmpty'), required),
          number: helpers.withMessage(i18n.global.t('page.expert-system.MustBeANumber'), number),
        },
      },
    },
  },
  watch: {
    threshold: {
      handler(val) {
        this.showThreshold = _.cloneDeep(val);
        this.showThreshold.static_threshold.state =
          val.static_threshold.state == 1 ? true : false;
        this.showThreshold.dynamic_threshold.state =
          val.dynamic_threshold.state == 1 ? true : false;
      },
      deep: true,
      immediate: true,
    },
    // isEdit: {
    //   handler(val) {
    //     if (val) {
    //       this.$emit("clearTimer");
    //     } else {
    //       this.$emit("refreshFrequency", this.refresh_frequency);
    //     }
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    // dyEdit: {
    //   handler(val) {
    //     if (val) {
    //       this.$emit("clearTimer");
    //     } else {
    //       this.$emit("refreshFrequency", this.refresh_frequency);
    //     }
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },
  data() {
    return {
      isEdit: false,
      dyEdit: false,
      submitted: false,
      showThreshold: {
        static_threshold: {},
        dynamic_threshold: {},
      },
    };
  },
  methods: {
    handleCancel() {
      this.showThreshold = _.cloneDeep(this.threshold);
      this.showThreshold.static_threshold.state =
        this.threshold.static_threshold.state == 1 ? true : false;
      this.showThreshold.dynamic_threshold.state =
        this.threshold.dynamic_threshold.state == 1 ? true : false;
      this.isEdit = false;
    },
    clickEdit() {
      if (!this.recordThreshold) {
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-light me-2",
          },
          buttonsStyling: false,
        });
        swalWithBootstrapButtons
          .fire({
            title: this.$t('page.expert-system.CurrentDetectionPointThresholdNotEnabled'),
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: this.$t('base.cancel'),
            confirmButtonText: this.$t('page.expert-system.go'),
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$router.push({
                path: "/asset/form",
                query: {
                  type: "edit",
                  title: this.$t('page.expert-system.EditObjectInstance'),
                  instance_id: this.instance_id,
                },
              });
            }
          });
        return;
      }
      this.isEdit = true;
    },
    handleEdit() {
      this.submitted = true;
      this.v$.$touch();
      if (this.v$.$invalid) return;

      let params = {
        id: this.measure_id,
        operationThresholdLow:
          this.showThreshold.static_threshold.operationThresholdLow,
        standardThresholdLow:
          this.showThreshold.static_threshold.standardThresholdLow,
        standardThresholdHigh:
          this.showThreshold.static_threshold.standardThresholdHigh,
        operationThresholdHigh:
          this.showThreshold.static_threshold.operationThresholdHigh,
      };
      putMeasureStaticThres(this.instance_id, params)
        .then((res) => {
          if (res.payload) {
            this.isEdit = false;
            //刷新数据
            this.$emit("showTable", this.currentInfo);
            this.$emit(
              "handleAlert",
              "success",
              this.$t('page.expert-system.ChangingStaticThresholdSucceeded'),
              "ri-check-double-line"
            );
          }
        })
        .catch(() => {
          this.isEdit = false;
          this.$emit("handleAlert", "danger", this.$t('page.expert-system.FailedModifyStaticThresholdPleaseTryAgain'));
        });
    },
    handleDyCancel() {
      this.dyEdit = false;
    },
    clickDyEdit() {
      this.dyEdit = true;
    },
    handleDyEdit() {
      this.submitted = true;
      this.dyEdit = false;
    },
    handleAlertInfo() {
      if (!this.recordThreshold) {
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-light me-2",
          },
          buttonsStyling: false,
        });
        swalWithBootstrapButtons
          .fire({
            title: this.$t('page.expert-system.StaticThresholdSwitchCannotBeOperated'),
            icon: "warning",
            showCancelButton: true,
            cancelButtonText: this.$t('base.cancel'),
            confirmButtonText: this.$t('page.expert-system.go'),
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.$router.push({
                path: "/asset/form",
                query: {
                  type: "edit",
                  title: this.$t('page.expert-system.EditObjectInstance'),
                  instance_id: this.instance_id,
                },
              });
            }
          });
        return;
      }
    },
    handleStaticStat(state) {
      let params = {
        id: this.measure_id,
        enabled: state.target.checked === true ? 1 : 0,
      };
      putMeasureStaticThresStat(this.instance_id, params)
        .then((res) => {
          if (res.payload) {
            //刷新数据
            this.$emit("showTable", this.currentInfo);
            this.$emit(
              "handleAlert",
              "success",
                `${this.$t('page.event-management.StatusChangedSuccessfully')}!`,
              "ri-check-double-line"
            );
          }
        })
        .catch(() => {
          this.$emit("handleAlert", "danger", this.$t('page.event-management.FailedModifyStatusPleaseTryAgain'));
        });
    },
    handleDynamicStat(state) {
      let params = {
        id: this.measure_id,
        enabled: state.target.checked === true ? 1 : 0,
      };
      putDynamicStat(this.instance_id, params)
        .then((res) => {
          if (res.payload) {
            //刷新数据
            this.$emit("showTable", this.currentInfo);
            this.$emit(
              "handleAlert",
              "success",
                `${this.$t('page.event-management.StatusChangedSuccessfully')}!`,
              "ri-check-double-line"
            );
          }
        })
        .catch(() => {
          this.$emit("handleAlert", "danger", this.$t('page.event-management.FailedModifyStatusPleaseTryAgain'));
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.noborder_input {
  border: none;
  outline: none;
  border-bottom: 1px solid #ccc;
}
</style>
